// extracted by mini-css-extract-plugin
export default {"root":"IconArrowRight_root__uvLF3"};